import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./AdminAuth.css";

function AdminLogin() {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const handleLogin = (e) => {
    e.preventDefault();

    const storedAdmin = JSON.parse(localStorage.getItem("admin"));

    if (!storedAdmin) {
      alert("No Admin account found. Please Signup first.");
      return;
    }

    if (email === storedAdmin.email && password === storedAdmin.password) {
  
  
  localStorage.setItem("token", "admin123");

  localStorage.setItem(
    "user",
    JSON.stringify(storedAdmin)
  );

  alert("Admin Login Successful!");
  navigate("/admin/dashboard");

} else {
  alert("Invalid Email or Password");
}

  };

 return (
  <div className="admin-container">
    <div className="admin-card">
      <h2> Login</h2>

      <form onSubmit={handleLogin}>
        <input
          type="email"
          placeholder="Admin Email"
          onChange={(e) => setEmail(e.target.value)}
          required
        />

        <input
          type="password"
          placeholder="Password"
          onChange={(e) => setPassword(e.target.value)}
          required
        />

        <button type="submit">Login</button>
      </form>

      <p>
        Don’t have admin account? <Link to="/admin/signup">Signup</Link>
      </p>

      <p>
        <Link to="/admin/forgot-password">Forgot Password?</Link>
      </p>
    </div>
  </div>
);

}

export default AdminLogin;  